module.exports = __webpack_public_path__ + "6ec691099fbaaef797d01db9eccf9284.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-420.webp
// module id = 215
// module chunks = 0